import { useAppSelector } from 'app/hooks';
import { Text } from 'blocks/Text';
import Loading from 'components/Loading';
import { priceFormat } from 'helper/common';
import FlightPriceResponseInterface from 'models/flight/flightPriceResponse.interface';
import { BookingClassAvail } from 'models/flight/flightSegments.interface';
import { OriginDestinationOption } from 'models/flight/flitghtResponse.interface';
import { Maybe } from 'models/types';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { getDiscountPrice } from 'services/discountFlight.service';
import { getFlightPrice } from 'services/flight.service';
import { formPassengersDataState, setSelectedFlight, setSelectedFlightPrice } from 'store/flight/flightSlice';
import { isLTRState } from 'store/options/optionsSlice';
import { FlightCardAmountBlockProps } from './FlightCardAmountBlock.interface';
import * as S from './FlightCardAmountBlock.styles';

const FlightCardAmountBlock = ({
  flight,
  userTierMilage,
  availClass,
  availType,
  cabinClassTitle,
  discountTicketId,
  onSelect,
}: FlightCardAmountBlockProps) => {
  const { t } = useTranslation();
  const [amount, setAmount] = useState<Maybe<FlightPriceResponseInterface>>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [onHover, setOnHover] = useState<boolean>(false);
  const [relatedClass, setRelatedClass] = useState<Maybe<BookingClassAvail>>(null);
  const isLTR = useAppSelector(isLTRState);
  const passengerList = useAppSelector(formPassengersDataState);

  const dispatch = useDispatch();

  useEffect(() => {
    const relatedClasses = [] as BookingClassAvail[];
    const hasRelatedClass = flight.originDestinationOption.every((e) => {
      return e.flightSegment.every((el) => {
        return el.bookingClassAvails.bookingClassAvail.some((ele) => {
          if (ele.resBookDesigCode === availClass) {
            relatedClasses.push(ele);
            return true;
          }
          //TODO: up
          if (availType && ele.type === availType) {
            relatedClasses.push(ele);
            return true;
          }
          return false;
        });
      });
    });
    const relatedClass = flight.originDestinationOption[0].flightSegment[0].bookingClassAvails.bookingClassAvail.find(
      (ele) => {
        if (ele.resBookDesigCode === availClass) {
          return true;
        }
        if (availType && ele.type === availType) {
          return true;
        }
        return false;
      }
    );

    setRelatedClass(relatedClass || null);
  }, [flight, availClass]);

  const prepareOriginDestionationOption = (data): OriginDestinationOption[] => {
    const originDestinationOption: OriginDestinationOption[] = JSON.parse(JSON.stringify(data));
    const preparedData = originDestinationOption.map((e) => {
      e.flightSegment = e.flightSegment.map((el) => {
        const foundedBookingClassAvail = el.bookingClassAvails.bookingClassAvail.filter((ele) => {
          if (ele.resBookDesigCode === availClass) {
            return true;
          }
          if (availType && ele.type === availType) {
            return true;
          }
          return false;
        });

        el.bookingClassAvails.bookingClassAvail = foundedBookingClassAvail;
        return el;
      });
      return e;
    });
    return preparedData;
  };

  const getAmount = async () => {
    setLoading(true);
    if (!!discountTicketId) {
      getDiscountPrice({
        originDestinationOption: prepareOriginDestionationOption(flight.originDestinationOption),
        discountTicketId: discountTicketId,
      })
        .then((res) => {
          setAmount(res);
        })
        .catch((ex) => toast.error(ex?.response?.data?.message))
        .finally(() => {
          setLoading(false);
        });
    } else
      getFlightPrice({
        originDestinationOption: prepareOriginDestionationOption(flight.originDestinationOption),
        adtCount: passengerList.adult || 1,
        chdCount: passengerList.child,
        infCount: passengerList.infant,
      })
        .then((res) => {
          setAmount(res);
        })
        .catch((ex) => toast.error(ex?.response?.data?.message))
        .finally(() => {
          setLoading(false);
        });
  };

  const selectFlight = () => {
    if (!amount) {
      return;
    }
    if (amount.totalMilage && userTierMilage < amount.totalMilage) {
      toast.error(t('pages.services.flight.pages.book.sections.list.errors.needMoreMilesToBook'));
    } else {
      dispatch(setSelectedFlightPrice(amount));

      dispatch(
        setSelectedFlight({
          originDestinationOption: prepareOriginDestionationOption(
            amount?.pricedItineraries.pricedItinerary[0].airItinerary.originDestinationOptions.originDestinationOption
          ),
        })
      );
      onSelect();
    }
  };
  const IsEmptyValue = !relatedClass?.resBookDesigQuantity || relatedClass?.resBookDesigQuantity === '0';

  return (
    <>
      <S.Wrapper>
        <S.AmountBlock
          $isEmpty={IsEmptyValue}
          onMouseOver={() => {
            setOnHover(true);
          }}
          onMouseLeave={() => {
            setOnHover(false);
          }}
        >
          <S.TopBlock>
            <S.CabinClass>{cabinClassTitle}</S.CabinClass>
            <S.AvailabilityBlock $isEmpty={IsEmptyValue}>
              {t('pages.services.flight.pages.book.sections.list.card.availability', {
                count: parseInt(relatedClass?.resBookDesigQuantity || '0'),
              })}
            </S.AvailabilityBlock>
          </S.TopBlock>
          {loading ? (
            <Loading size="small" fullScreen={false} height="40px" />
          ) : (
            <S.Content $isEmpty={IsEmptyValue}>
              {amount ? (
                <S.AmountDetailsBlock onClick={selectFlight}>
                  <S.AmountDetailsMiles $isLTR={isLTR}>
                    <S.AmountText>{priceFormat(amount.totalMilage)}</S.AmountText>
                    <S.SubText>
                      <Text size="small">{t('constants.miles')}</Text>
                    </S.SubText>
                  </S.AmountDetailsMiles>
                  <S.AmountDetailsPrice $isLTR={isLTR}>
                    <Text size="small">+</Text>
                    <S.AmountText>
                      {priceFormat(
                        amount.pricedItineraries.pricedItinerary[0].airItineraryPricingInfo.itinTotalFare[0].totalFare
                          .amount
                        //   -
                        // amount.pricedItineraries.pricedItinerary[0].airItineraryPricingInfo.itinTotalFare[0].baseFare
                        //   .amount
                      )}
                    </S.AmountText>
                    <S.SubText>
                      <Text size="small">{t('constants.currency')}</Text>
                    </S.SubText>
                  </S.AmountDetailsPrice>
                  <S.AmountDetailsDescription>
                    <Text size="small">
                      {t('pages.services.flight.pages.book.sections.list.card.amount.description')}
                    </Text>
                  </S.AmountDetailsDescription>
                  <S.AmountBlockFloatBtn $onHover={onHover}>
                    <Text size="small" color="white">
                      {t('pages.services.flight.pages.book.sections.list.card.amount.selectCTA')}
                    </Text>
                  </S.AmountBlockFloatBtn>
                </S.AmountDetailsBlock>
              ) : !relatedClass?.resBookDesigQuantity ? (
                <S.EmptyBlock>
                  <S.EmptyBlockText $isEmpty={IsEmptyValue}>
                    {t('pages.services.flight.pages.book.sections.list.card.getAmountCTAfull')}
                  </S.EmptyBlockText>
                </S.EmptyBlock>
              ) : (
                <S.EmptyBlock onClick={getAmount}>
                  <S.EmptyBlockText $isEmpty={IsEmptyValue}>
                    {t('pages.services.flight.pages.book.sections.list.card.getAmountCTA')}
                  </S.EmptyBlockText>
                </S.EmptyBlock>
              )}
            </S.Content>
          )}
        </S.AmountBlock>
      </S.Wrapper>
    </>
  );
};
export default FlightCardAmountBlock;
